import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { ListQuote } from "../../types/Quote";

export const getListQuotes = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["quotes", dossierId],
    queryFn: (): Promise<ListQuote[]> => {
      return fetchWithAuth<ListQuote[]>("getDossierQuotes", dossierId);
    },
    enabled: isQueryEnabled(options),
  });
};
